import React, { Component } from 'react';
import moment from 'moment';

import { withRouteOptions } from 'components/hocs/withRouteOptions';
import PersonTimetableTable from './PersonTimetableTable';

@withRouteOptions
export default class PersonTimetable extends Component {
    static routeOptions = {
        title: 'menu.personTimetable'
    }

    state = {
        datefrom: moment().startOf('month'),
        dateto: moment().endOf('month')
    }

    setDateRange = dates => {
        const [ datefrom, dateto ] = dates;

        this.setState({ datefrom, dateto });
    }

    render() {
        const { datefrom, dateto } = this.state;
        const { project } = this.props.match.params;

        return (
            <PersonTimetableTable
                datefrom={datefrom}
                dateto={dateto}
                project={project}
                setDateRange={this.setDateRange}
            />
        );
    }
}
